import { motion } from "framer-motion";

const IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1758523671893-0ba21cf4260f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    title: "Move-in day, sorted.",
    tag: "Residential",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    url: "https://images.pexels.com/photos/20706506/pexels-photo-20706506.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title: "Loaded with care.",
    tag: "Loading & Wrapping",
    span: "md:col-span-5",
  },
  {
    url: "https://images.unsplash.com/photo-1577354895838-71a732df3581?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    title: "Door-to-door delivery.",
    tag: "Logistics",
    span: "md:col-span-5",
  },
  {
    url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=80",
    title: "From studios to estates.",
    tag: "Every size",
    span: "md:col-span-4",
  },
  {
    url: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=80",
    title: "Junk hauled. Space restored.",
    tag: "Junk Removal",
    span: "md:col-span-4",
  },
  {
    url: "https://images.unsplash.com/photo-1605152276897-4f618f831968?auto=format&fit=crop&w=1600&q=80",
    title: "A crew you can trust.",
    tag: "Our team",
    span: "md:col-span-4",
  },
];

export default function Gallery() {
  return (
    <section data-testid="gallery-section" id="gallery" className="relative py-28 sm:py-36 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="text-[10px] tracking-[0.4em] uppercase font-semibold text-amber-700 mb-4">The crew · The work</p>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl font-light tracking-[-0.03em] leading-[0.95] text-stone-950 max-w-3xl">
              Real movers.<br />
              <span className="italic">Real moves.</span>{" "}
              <span className="text-stone-400">No surprise fees.</span>
            </h2>
          </div>
          <p className="text-base text-stone-600 max-w-md leading-relaxed">
            From studio apartments to full estate cleanouts, our team shows up early, wraps everything,
            and treats your stuff like our own.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 md:grid-rows-2 gap-4 md:gap-5">
          {IMAGES.map((img, i) => (
            <motion.figure
              key={img.url}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className={`relative overflow-hidden border border-stone-300/80 rounded-sm group bg-stone-100 ${img.span}`}
              style={{ minHeight: 260 }}
            >
              <img
                src={img.url}
                alt={img.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950/85 via-stone-950/15 to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 p-6 sm:p-8 text-stone-50">
                <span className="inline-block text-[10px] tracking-[0.35em] uppercase font-semibold text-amber-400 mb-2">
                  {img.tag}
                </span>
                <h3 className="font-display text-2xl sm:text-3xl font-light leading-[1.05] tracking-[-0.02em]">
                  {img.title}
                </h3>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
